export const styles = (theme, drawerOpen) => ({
    appLayoutContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    appDrawerAndContentContainer: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '64px',
    },
    appLayoutContent: {
        minHeight: '100vh',
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        padding: '3rem',
        position: 'relative',
        overflow: "auto",
    },

    appBar: {
        backgroundColor: theme.palette.primary.main,
        zIndex: 1201,
        top: 0,
        left: 0,
        right: 0
    },
    appLayoutDrawer: {
        flexShrink: 0,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        '& .MuiDrawer-paper': {
            width: drawerOpen ? 220 : 60,
            backgroundColor: theme.brand.field,
            color: theme.palette.text.primary,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            overflowX: 'hidden',
            position: 'relative',
            borderRight: `1px solid ${theme.palette.divider}`,
        },
        '& .MuiListItemButton-root': {
            borderLeft: '3px solid transparent',
            minHeight: 44,
            '& .MuiListItemIcon-root': {color: theme.palette.text.secondary},
            '& .MuiListItemText-primary': {color: theme.palette.text.primary},
            '&:hover': {backgroundColor: theme.palette.action.hover},
        },
        '& .MuiListItemButton-root.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            borderLeftColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root': {color: theme.palette.primary.main},
            '& .MuiListItemText-primary': {color: theme.palette.primary.main, fontWeight: 600},
            '&:hover': {backgroundColor: theme.palette.action.selected},
        },
        zIndex: 1,
    },

    drawerContentContainer: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
    },
    sectionHeader: {
        display: 'block',
        padding: theme.spacing(2, 2.5, 0.5),
        fontFamily: theme.brand.fonts.mono,
        fontSize: '0.62rem',
        fontWeight: 700,
        letterSpacing: '0.09em',
        textTransform: 'uppercase',
        color: theme.palette.text.secondary,
    },
    groupDivider: {
        margin: theme.spacing(1, 1.5),
        borderColor: theme.palette.divider,
    },
    toolbar: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        minHeight: 64,
        paddingLeft: 24,
        paddingRight: 24
    },
    leftSection: {
        display: 'flex',
        alignItems: 'center',
        zIndex: 1
    },
    centerSection: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 0
    },
    rightSection: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        zIndex: 1
    },
    brandContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    brandName: {
        padding: theme.spacing(2)
    },
    brandLogo: {
        borderRadius: '25px',
        height: 50,
        margin: 'auto'
    },
    totalesTable: {
        width: 'auto',
        borderCollapse: 'collapse',
        marginTop: '10px'
    },
    totalesCell: {
        padding: '3px 5px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        textAlign: 'left',
        paddingRight: '100px'
    },
    totalesValueCell: {
        padding: '3px 5px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
        textAlign: 'right',
        paddingBottom: '2px'
    },
    totalesRowCell: {
        padding: '3px 5px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
        textAlign: 'left',
        paddingRight: '100px',
        fontSize: '18px',
        fontWeight: 'bold',
        paddingTop: '15px',
        lineHeight: '1.2'
    },
    totalesRowValueCell: {
        padding: '3px 5px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
        textAlign: 'right',
        fontSize: '18px',
        fontWeight: 'bold',
        paddingTop: '15px',
        lineHeight: '1.2'
    },
    totalesRegularRowCell: {
        paddingBottom: '2px'
    },
});
